import { render, staticRenderFns } from "./ConfiguracionComponent.vue?vue&type=template&id=7993a053&scoped=true"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=js"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionComponent.vue?vue&type=style&index=0&id=7993a053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993a053",
  null
  
)

export default component.exports